<template>
    <button :class="cssClass" @click.prevent="handleClick">
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: ['mode', 'to'],
    computed: {
        cssClass() {
            return "router-button "+this.mode;
        }
    },
    methods: {
        handleClick() {
            this.$router.replace(this.to);
        }
    }
}    
</script>

<style lang="scss">
.router-button {
    text-align:center;
    display:block;
    margin: 0 auto;
    font-size:30px;
    border-collapse: collapse;
    border:none;
    max-width: 320px;
    width: 80%;
    min-height: 64px;
    line-height: 64px;
    cursor:pointer;
    text-decoration: none;
    font-family: 'Oswald-Light', sans-serif;
    

    &:focus {
        outline:none;
        outline-width: 0;
    }

    &.primary {
        background:#FFF;
        color: #000;
        border-radius:60px 60px;
    }
    &.secondary {
        background:none;
        color:rgba(251, 198, 131, 0.8);
    }
}
</style>
